module.exports = __webpack_public_path__ + "img/only_pdf_icon.bdd0241d.svg";